<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        placeholder="请输入专题ID"
        v-model="params.id"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入模块名称"
        v-model="params.moduleName"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        placeholder="请输入亚模块名称"
        v-model="params.subModuleName"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-select
        v-model="params.type"
        placeholder="请选择类型"
        clearable
        size="small"
      >
        <el-option
          v-for="item in types"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="params.status"
        placeholder="请选择是否启用"
        clearable
        size="small"
      >
        <el-option
          v-for="item in enables"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getModules('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
      <el-button
        type="warning"
        size="small"
        @click="setMarquee()"
        style="margin-right: 20px"
        >配置模块跑马灯</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="600"
    >
      <el-table-column prop="id" label="专题id" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="deletedAt"
        label="删除时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.deletedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="moduleName"
        label="模块名称"
        align="center"
        min-width="150"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.moduleName || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="封面图" align="center" width="80">
        <template slot-scope="scope">
          <img-load
            :width="'60px'"
            :height="'80px'"
            :src="imgUrl + scope.row.backGround"
          ></img-load>
        </template>
      </el-table-column>
      <el-table-column
        prop="sectionLimit"
        label="专题数量限制"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sectionLimit }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sortNum"
        label="排序"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.sortNum || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" min-width="120">
        <template slot-scope="scope">
          <el-tag
            style="background-color: #ecf5ff;color: #409eff;border: 1px solid #d9ecff;"
            v-if="scope.row.type === 1"
            >首页</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.type === 2">社区</el-tag>
          <el-tag type="warning" v-else-if="scope.row.type === 3">游戏</el-tag>
          <el-tag type="danger" v-else-if="scope.row.type === 4">漫画</el-tag>
          <el-tag plain type="danger" v-else-if="scope.row.type === 5"
            >动漫</el-tag
          >
          <el-tag plain type="success" v-else-if="scope.row.type === 6"
            >小说</el-tag
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="showType"
        label="展示类型"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag
            style="background-color: #ecf5ff;color: #409eff;border: 1px solid #d9ecff;"
            v-if="scope.row.showType === 1"
            >专题样式</el-tag
          >
          <el-tag type="success" v-else>海角系样式</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === 1">启用</el-tag>
          <el-tag type="danger" v-if="scope.row.status === 0">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="subModuleName"
        label="亚模块名称"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.subModuleName || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="180"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      @before-close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item label="模块名称" prop="moduleName">
          <el-input v-model="form.moduleName"></el-input>
        </el-form-item>
        <el-form-item label="亚模块名称" prop="subModuleName">
          <el-input v-model="form.subModuleName"></el-input>
        </el-form-item>
        <el-form-item label="数量限制" prop="sectionLimit">
          <el-input v-model.number="form.sectionLimit"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sortNum">
          <el-input v-model.number="form.sortNum"></el-input>
        </el-form-item>
        <el-form-item label="背景图上传:" prop="backGround">
          <base-upload
            :cover="form.backGround"
            :action="action"
            @successCallback="successCallback"
            :wSize="360"
            :hSize="640"
            :width="'213px'"
            :height="'120px'"
          ></base-upload>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="展示类型">
          <el-select v-model="form.showType" placeholder="请选择展示类型">
            <el-option
              v-for="item in showTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-select v-model="form.status" placeholder="请选择是否启用">
            <el-option
              v-for="item in enables"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 配置跑马灯 -->
    <el-dialog
      title="配置跑马灯"
      :visible.sync="marqueeVisible"
      width="500px"
      @before-close="handleClose"
      v-loading="marqueeLoading"
    >
      <el-form :model="marqueeForm" :rules="rules" ref="form">
        <el-form-item label="跑马灯内容" prop="marqueeStr">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            class="inp"
            v-model="marqueeForm.marqueeStr"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="marqueeVisible = false">取 消</el-button>
        <el-button type="primary" @click="editMarquee()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 表格数据加载动画
      imgUrl: baseConfig.imgUrl,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      loading: false,
      enables: [
        { label: "启用", value: 1 },
        { label: "禁用", value: 0 },
      ],
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
      form: {
        id: "",
        moduleName: "",
        subModuleName: "",
        sectionLimit: undefined,
        sortNum: undefined,
        backGround: undefined,
        type: 1,
        showType: 0,
        status: 1,
      },
      types: [
        { label: "首页", value: 1 },
        { label: "社区", value: 2 },
        { label: "游戏", value: 3 },
        { label: "漫画", value: 4 },
        { label: "动漫", value: 5 },
        { label: "小说", value: 6 },
      ],
      showTypes: [
        { label: "海角系样式", value: 0 },
        { label: "专题样式", value: 1 },
      ],
      dialogVisible: false,
      dialogTitle: "",
      rules: {
        moduleName: [
          { required: true, message: "请输入模块名称", trigger: "blur" },
        ],
        subModuleName: [
          { required: true, message: "请输入亚模块名称", trigger: "blur" },
        ],
        sectionLimit: [
          { required: true, message: "请输入数量限制", trigger: "blur" },
        ],
        marqueeStr: [
          { required: true, message: "请输入跑马灯内容", trigger: "blur" },
        ],
      },
      // 跑马灯
      marqueeLoading: false,
      marqueeVisible: false,
      marqueeForm: {
        marqueeStr: "",
      },
    };
  },
  created() {
    this.getModules();
  },
  methods: {
    // 请求列表
    getModules(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getModules(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.form.backGround = res.data.coverImg;
    },
    // 新增标签配置
    addAndEdit(param) {
      this.dialogVisible = true; // 打开新增、编辑对话框
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.moduleName = param.moduleName;
        this.form.subModuleName = param.subModuleName;
        this.form.sectionLimit = param.sectionLimit;
        this.form.status = param.status;
        this.form.showType = param.showType;
        this.form.type = param.type;
        this.form.backGround = param.backGround;
        this.form.sortNum = param.sortNum ? param.sortNum : undefined;
      }
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const addData = {
            moduleName: this.form.moduleName,
            subModuleName: this.form.subModuleName,
            sectionLimit: this.form.sectionLimit,
            status: this.form.status,
            showType: this.form.showType,
            type: this.form.type,
          };
          API.addModule(addData)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
                this.dialogVisible = false;
                this.getModules();
              } else {
                this.$message({
                  type: "error",
                  message: "新增失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.editModule(this.form)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "编辑成功",
                });
                this.dialogVisible = false;
                this.getModules();
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常",
              });
            });
        } else {
          return false;
        }
      });
    },
    // 删除方法
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.moduleName}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.deleteModule(delData)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "success",
                  message: "删除失败!",
                });
              }
              this.getModules();
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.moduleName = "";
      this.form.subModuleName = "";
      this.form.sectionLimit = undefined;
      this.form.sortNum = undefined;
      this.form.backGround = undefined;
      this.form.type = 1;
      this.form.status = 1;
      this.form.showType = 0;
      this.dialogVisible = false;
      this.marqueeLoading = false;
      this.marqueeForm.marqueeStr = false;
    },
    // 配置跑马灯
    setMarquee() {
      this.marqueeVisible = true;
      this.marqueeLoading = true;
      API.queryMarquee()
        .then((res) => {
          if (res.code === 200) {
            this.marqueeForm.marqueeStr = res.data.content;
            this.marqueeLoading = false;
          } else {
            this.$message({
              type: "success",
              message: "查询失败!",
            });
            this.marqueeLoading = false;
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "服务器异常!",
          });
          this.marqueeLoading = false;
        });
    },
    // 修改跑马灯
    editMarquee() {
      if (!this.marqueeForm.marqueeStr) return;
      API.modifyMarquee({ marquee: this.marqueeForm.marqueeStr })
        .then((res) => {
          if (res.code === 200) {
            this.marqueeVisible = false;
            this.$message({
              type: "success",
              message: "修改成功",
            });
          } else {
            this.$message({
              type: "success",
              message: "修改失败!",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "服务器异常!",
          });
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getModules();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getModules();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
</style>
